module.exports = __webpack_public_path__ + "img/icon-result-0.c62d7f9a.svg";